module.exports = __webpack_public_path__ + "static/volatility_icon-5bee8a97a5d9398cb4b7731f6ab79434.svg";